// extracted by mini-css-extract-plugin
export default {"container":"SectionImages_container__1IdAo","image":"SectionImages_image__q2FvL","credit":"SectionImages_credit__2VVSb"};